import React from 'react';
import InviteAcceptanceForm from '../components/invite/InviteAcceptanceForm';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../Auth';

const InviteAcceptancePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const auth = useAuth();

  // The invitation id is passed as a query param: /accept-invite?id=xxx
  const invitationId = searchParams.get('id');

  const handleAccepted = () => {
    // After successfully accepting, force a full page reload to refresh
    // the session with the new organization membership
    window.location.href = '/home';
  };

  // If user is not logged in, show a prompt to log in first
  if (!auth.user) {
    return (
      <div className="min-h-dvh bg-surface flex items-center justify-center p-6">
        <div className="card max-w-md w-full">
          <div className="card-body text-center">
            <span className="material-icons-outlined text-4xl text-tertiary mb-4 block">mail_outline</span>
            <h1 className="text-2xl font-display font-bold text-on-surface mb-2">You've Been Invited!</h1>
            <p className="text-on-surface-variant/60 text-sm mb-6">
              Sign in or create an account to accept your invitation.
            </p>
            <div className="flex flex-col gap-3">
              <button
                onClick={() => navigate('/login', { state: { from: `/accept-invite?id=${invitationId}` } })}
                className="btn btn-primary"
              >
                Sign In
              </button>
              <button
                onClick={() => navigate('/signup', { state: { from: `/accept-invite?id=${invitationId}` } })}
                className="btn btn-ghost"
              >
                Create Account
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-dvh bg-surface flex items-center justify-center p-6">
      <div className="card max-w-md w-full">
        <div className="card-body">
          <h1 className="text-2xl font-display font-bold text-on-surface mb-4">Accept Invitation</h1>
          {invitationId ? (
            <InviteAcceptanceForm invitationId={invitationId} onAccepted={handleAccepted} />
          ) : (
            <div className="text-center py-8">
              <span className="material-icons-outlined text-3xl text-on-surface-variant/15 block mb-2">link_off</span>
              <p className="text-on-surface-variant/60 text-sm">
                No invitation token provided. Please check the link and try again.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InviteAcceptancePage;